import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$orgSlug/admin/map/$mapSlug/tags")({
  // Component moved to $orgSlug.admin.map.$mapSlug.tags.lazy.tsx for code splitting
});
